<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">数据中心</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">智呼助手统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-statistics">
           <div class="top-search" style="padding-top:16px">
                <a-row type="flex">
                    <a-col><label for="">通话日期：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" placeholder="今天" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

                <a-row  type="flex">
                    <a-col><label for="">部门/员工：</label></a-col>
                    <a-col>
                        <a-select default-value="lucy" style="width: 120px" @change="handleChange">
                            <a-select-option value="jack">
                                Jack
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </div>

            <div class="tj-charts" style="background: #f0f2f5;margin-bottom: 10px;display: flex;">
                <div style="width: 50%; margin-right: 10px;background:#fff">
                    <div id="weightChart" style="width: 260px;height:250px;"></div>
                </div>
                <div style="width:50%;background:#fff">
                     <div id="infoChart" style="width: 520px;height:250px;"></div>
                </div>
                
            </div>

            
            <div class="table-content">
                <div class="table-top-info">
                    <a-button icon="upload">导出</a-button>
                    <div>拨打次数：0</div>
                    <div>异常号码检测次数：￥0</div>
                    <div>拦截率：￥0</div>
                </div>

                <a-table :columns="columns" :data-source="data">
                    <a slot="name" slot-scope="text">{{ text }}</a>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '时间',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '拨打次数',
    dataIndex: 'age',
    key: 'age',
    width: 80,
  },
  {
    title: '异常号码检测次数',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true,
  },
  {
    title: '拦截率',
    dataIndex: 'address',
    key: 'num1',
    ellipsis: true,
  },
  {
    title: '接听率低',
    dataIndex: 'address',
    key: 'address 2',
    ellipsis: true,
  },
  {
    title: '通话意愿低',
    dataIndex: 'name',
    key: 'num1',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '空号',
    dataIndex: 'num2',
    key: 'num2',
    width: 80,
  },
  {
    title: '停机',
    dataIndex: 'num3',
    key: 'num3',
    ellipsis: true,
  },
  {
    title: '不推荐号码',
    dataIndex: 'num3',
    key: 'num4',
    ellipsis: true,
  }
];

const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];

export default {
    data(){
        return{
            data,
            columns,
        }
    },
    mounted(){
        this.drawLine()
    },
    methods:{
        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}%"
                },
                grid: {  
                    top:'6%', 
                    bottom: '14%',  
                    containLabel: true  
                }, 
                series: [
                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '6%',
                        maxSize: '45%',
                        sort: 'descending',
                        gap: 2,
                       
                        emphasis: {
                            label: {
                                fontSize: 14
                            }
                        },
                        data: [
                            {value: 90, name: '初步接洽',barHeight: 6},
                            {value: 75, name: '需求确定'},
                            {value: 60, name: '方案/报价'},
                            {value: 45, name: '谈判审核'},
                            {value: 30, name: '赢单'},
                            {value: 15, name: '输单'},
                        ]
                    }
                ]
            });


            var infoChart = this.$echarts.init(document.getElementById("infoChart"))
            infoChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top:50,
                    icon: "circle", 
                    itemGap: 16,
                    data: ['空号', '停机', '接听率低', '通话意愿低', '不推荐号码']
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['30%', '66%'],
                        avoidLabelOverlap: false,
                        center: ['40%', '54%'],
                        emphasis: {
                            label: {
                                show: true,
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: [
                            {value: 10, name: '空号',itemStyle:{normal:{color:'#6689fa'}}},
                            {value: 5, name: '停机',itemStyle:{normal:{color:'#62ccfd'}}},
                            {value: 20, name: '接听率低',itemStyle:{normal:{color:'#00e8b9'}}},
                            {value: 38, name: '通话意愿低',itemStyle:{normal:{color:'#8a67fb'}}},
                            {value: 6, name: '不推荐号码',itemStyle:{normal:{color:'#ffac45'}}}
                        ]
                    }
                ]
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/detectStatic.vue